
<template>
  <div class="main-content">

    <loading :active.sync="isLoading"
             :is-full-page="fullPage"></loading>

    <div class="row">
      <div class="col-md-12">

        <button class="btn btn-success float-right" v-b-modal.export-customers> Export </button>

      </div>
    </div>


    <br/>
    <b-table striped hover :items="customers" :fields="columns">
      <template v-slot:cell(loyaltyId)="data">
        {{ data.value }}
      </template>
      <template v-slot:cell(status)="data">
            <span  class="badge badge-success"  v-if="data.value == 'ACTIVE'">
                   {{ data.value }}
                </span>
        <span class="badge badge-danger"  v-else >
                  {{ data.value }}
            </span>
      </template>
      <template v-slot:cell(options)="data">

        <b-dropdown text="options">
          <b-dropdown-item href="#"  @click="openEditCustomerModal(data.item)">Edit</b-dropdown-item>
          <b-dropdown-item href="#" v-if="data.item.status == 'ACTIVE'" @click="openUpdateCustomerStatus('SUSPENDED', data.item)"  >Deactivate</b-dropdown-item>
          <b-dropdown-item href="#" v-else @click="openUpdateCustomerStatus('ACTIVE', data.item)"  >Activate</b-dropdown-item>
        </b-dropdown>
      </template>
    </b-table>

    <div class="row">
      <div class="col-md-12">

        <nav aria-label="Page navigation float-right" style="margin-top: 20px;">
          <ul class="pagination justify-content-center">
            <li v-if="pagination.current_page > 1" class="page-item"><a @click.prevent="changePage(pagination.current_page - 1)" class="page-link" href="#">Previous</a></li>
            <li v-for="page in pagesNumber"
                v-bind:class="[ page == isActived ? 'active' : '']" class="page-item"><a @click.prevent="changePage(page - 1)" class="page-link" href="#">{{ page }}</a></li>
            <li v-if="pagination.current_page < pagination.last_page"  class="page-item"><a  @click.prevent="changePage(pagination.current_page + 1)"class="page-link" href="#">Next</a></li>
          </ul>
        </nav>
      </div>
    </div>



    <b-modal id="export-customers" title="Export customers" @cancel="true" @ok="exportToExcel"   centered>
      <form action="#" class="form-horizontal"  method="post">
        <input type="hidden" name="_token" />
        <div class="form-body">
          <div class="row" >
            <div class="col-md-12">
              <div class="form-group ">
                <label class="control-label ">Please enter your email address:</label> <br/>
                <div >
                  <input class="form-control" type="text"  v-model="email_address" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

  </div>
</template>
<script>

  import { mapGetters, mapActions } from "vuex";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/index.css';
  import CodeInput from "vue-verification-code-input"

  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css'


export default {
  data() {
    return {
      phoneNumberDuplicate:"",
      phoneNumber:"",
      offset: 4,
      pref:"254",
      disabled:false,
      isLoading: false,
      fullPage: true,
      columns:["loyaltyId","name","mobileNumber","email","gender","dob","created", "status"],
      customers:[],
      ratings:[],
      rating_columns:["customer","rating","comments"],
      duplicate_columns:["name","phoneNumber","cashBalance","duplicateType","options"],
      genders:["Male","Female"],
      ratingsStats:{
        cumulativeRating:0,
      },
      email_address:"",
      start_date:"all",
      end_date:"all",
      customer:{
        name:"",
        mobileNumber:"",
        email:"",
        password:"N/A",
        dob:"",
        gender:"",
        id:0
      },
      phone_verified:false,
      verificationCode:"",
      customerVerificationCode:"",
      pagination: {
        total: 0,
        per_page: 2,
        from: 1,
        to: 0,
        current_page: 0
      },
      status:"",
      duplicates:[],
      duplicate:{
        id:0,
        name:"",
        phoneNumber:"",
        duplicateType:"Phone number",
        cashBalance:""
      }
    };
  },
  components: {
    Loading,
    DatePicker,
    CodeInput
  },
  computed:{
    isActived: function () {
      return this.pagination.current_page + 1;
    },
    pagesNumber: function () {
      if (!this.pagination.to) {
        return [];
      }
      var from = this.pagination.current_page - this.offset;
      if (from < 1) {
        from = 1;
      }
      var to = from + (this.offset * 2);
      if (to >= this.pagination.last_page) {
        to = this.pagination.last_page;
      }
      var pagesArray = [];
      while (from <= to) {
        pagesArray.push(from);
        from++;
      }
      return pagesArray;
    }
  },
  mounted (){
    this.getCustomersData();

  },
  methods: {
    ...mapActions(["getNewCustomers","exportNewCustomers"]),

    exportToExcel(){

      let self = this;
      this.isLoading = true;

      let outlet_id = 0;

      if(this.outlet){
        outlet_id = this.outlet.id;
      }


      this.exportNewCustomers({email: this.email_address})
        .then(function () {

          self.isLoading = false;

          self.$bvToast.toast("Export request received. We'll email you the report once its ready", {
            title: 'Success',
            variant: 'success',
            autoHideDelay: 5000,
            appendToast: false
          });

        })
        .catch(function (error) {

          self.isLoading = false;

          console.log(error);
        });
    },





    getCustomersData(){
      let self = this;
      this.getNewCustomers()
        .then(function (customers) {
          self.customers = customers;
        })
        .catch(function (error) {

          if( typeof error.response.status != "undefined"){
            if(error.response.status == 401){
              location.replace("/login");
            }

          }
        })
    },

  }
};
</script>
